<template>
  <v-dialog v-model="mostrado" scrollable width="95vw">
    <v-card class="modal-comprobante-card">
      <v-card-title class="pt-2 pb-0">COMPROBANTE DE REVERSIÓN</v-card-title>

      <v-divider class="my-2"></v-divider>

      <v-card-text class="pt-2">
        <v-progress-linear v-if="cargando" indeterminate color="primary" class="mb-4" />

        <template v-if="!cargando && comprobante">
          <v-row dense class="fila-comprobante">
            <v-col cols="12" lg="7">
              <v-simple-table dense class="mb-3">
                <tbody>
                  <tr>
                    <td class="font-weight-bold caption">Número de Comprobante</td>
                    <td class="caption">{{ comprobante.numero_comprobante }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold caption">Fecha y Hora</td>
                    <td class="caption">{{ formatearFecha(comprobante.fecha_hora) }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold caption">Monto</td>
                    <td class="caption">{{ Number(comprobante.monto || 0).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold caption">Registrado por</td>
                    <td class="caption">{{ comprobante.registrado_por }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold caption">Registrado el</td>
                    <td class="caption">{{ formatearFecha(comprobante.creado_en) }}</td>
                  </tr>
                </tbody>
              </v-simple-table>

              <p class="subtitle-2 mb-1">Detalles asociados ({{ comprobante.detalles_solicitudes.length }})</p>
              <v-simple-table dense>
                <thead>
                  <tr>
                    <th></th>
                    <th>ID</th>
                    <th>Clasificador</th>
                    <th>Sede Origen</th>
                    <th>Sede Destino</th>
                    <th class="text-right">Importe</th>
                    <th>Detalle Original (Revertido)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="detalle in comprobante.detalles_solicitudes" :key="detalle.id">
                    <td class="text-center">
                      <v-icon v-if="detalle.id === detalleResaltadoId" small color="amber darken-2">
                        mdi-arrow-right-bold-circle
                      </v-icon>
                    </td>
                    <td class="caption">{{ detalle.id }}</td>
                    <td class="caption">
                      <span v-if="detalle.clasificador">
                        {{ detalle.clasificador.codigo }} - {{ detalle.clasificador.nombre }}
                      </span>
                      <span v-else>-</span>
                    </td>
                    <td class="caption">{{ detalle.sede_origen || '-' }}</td>
                    <td class="caption">{{ detalle.sede_destino || '-' }}</td>
                    <td class="caption text-right">{{ Number(detalle.importe || 0).toFixed(2) }}</td>
                    <td class="caption">
                      <span v-if="detalle.revertido">
                        {{ detalle.revertido.detalle }} (Bs. {{ Number(detalle.revertido.importe || 0).toFixed(2) }})
                      </span>
                      <span v-else>-</span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="5" class="text-right font-weight-bold caption">Total:</td>
                    <td class="text-right font-weight-bold caption">{{ totalImporte }}</td>
                    <td></td>
                  </tr>
                </tbody>
              </v-simple-table>

              <p v-if="detalleResaltadoId" class="caption grey--text mt-1 mb-0">
                <v-icon x-small color="amber darken-2">mdi-arrow-right-bold-circle</v-icon>
                Detalle desde el cual se abrió este comprobante.
              </p>
            </v-col>

            <v-col cols="12" lg="5" class="d-flex">
              <div class="d-flex justify-center align-center contenedor-previsualizacion">
                <v-img v-if="esImagen" :src="archivoSrc" contain height="100%" width="100%" />
                <iframe v-else-if="esPDF" :src="archivoSrc" style="border: none; width: 100%; height: 100%"></iframe>
                <v-icon v-else large color="grey lighten-1">mdi-image-broken-variant</v-icon>
              </div>
            </v-col>
          </v-row>
        </template>
      </v-card-text>

      <v-divider class="my-2"></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import comprobanteReversionService from '../services/comprobante-reversion';

export default {
  name: 'ModalVerComprobanteReversion',
  data() {
    return {
      mostrado: false,
      cargando: false,
      comprobante: null,
      detalleResaltadoId: null,
    };
  },
  computed: {
    esImagen() {
      return !!this.comprobante?.archivo?.mimetype?.includes('image');
    },
    esPDF() {
      return !!this.comprobante?.archivo?.mimetype?.includes('pdf');
    },
    archivoSrc() {
      if (!this.comprobante?.archivo) return null;
      return `data:${this.comprobante.archivo.mimetype};base64,${this.comprobante.archivo.file64}`;
    },
    totalImporte() {
      return this.comprobante.detalles_solicitudes.reduce((s, d) => s + Number(d.importe || 0), 0).toFixed(2);
    },
  },
  methods: {
    async abrir(id, detalleId = null) {
      this.mostrado = true;
      this.cargando = true;
      this.comprobante = null;
      this.detalleResaltadoId = detalleId;

      try {
        const response = await comprobanteReversionService.obtenerPorId(id);
        this.comprobante = response?.data?.datos;
      } catch (error) {
        window.console.error({ error });
        const data = error?.response?.data;
        const mensaje = data?.mensaje;

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Ocurrió un error al obtener el comprobante de reversión',
          type: 'error',
        });

        this.cerrar();
      }

      this.cargando = false;
    },
    cerrar() {
      this.mostrado = false;
    },
    formatearFecha(fecha) {
      return fecha ? moment(fecha).format('DD/MM/YYYY HH:mm') : '-';
    },
  },
};
</script>

<style scoped>
.modal-comprobante-card {
  height: 90vh;
  display: flex;
  flex-direction: column;
}

.modal-comprobante-card ::v-deep .v-card__text {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.fila-comprobante {
  height: 100%;
  margin: 0;
}

.contenedor-previsualizacion {
  border: 1px solid #c5c5c5;
  border-radius: 5px;
  padding: 10px;
  width: 100%;
  height: 100%;
  min-height: 300px;
  background-color: #f5f5f5;
}
</style>
